<template>
    <div style="">
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 50px;padding-top: 50px;">
            <div style="width:1200px">
                <el-container style="padding-top: 50px;">
                    <el-aside width="220px">
                        <hd-aside></hd-aside>
                    </el-aside>
                    <el-main style="padding-top: 0;padding-bottom: 0;">
                        <el-card shadow="never" style="border: 0;padding-bottom: 100px;">
                            <p class="pTitle">教师认证</p>
                            <sub-teacher-agreement pre="/user-teacher-cer" next="/user-teacher-info">
                            </sub-teacher-agreement>
                        </el-card>
                    </el-main>
                </el-container>
            </div>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
    import HdHeader from '../public/Header.vue'
    import HdFooter from '../public/FooterLogined.vue'
    import HdAside from '../public/Aside.vue'
    import SubTeacherAgreement from '../public/sub/SubTeacherAgreement.vue'

    export default {
        name: 'UserTeacherAgreement',
        components: {
            HdHeader,
            HdFooter,
            HdAside,
            SubTeacherAgreement
        }
    }
</script>

<style>
    body {
        background-color: #F8F8F8;
    }

    .pTitle {
        border-bottom: 1px solid #d6d6da;
        padding-bottom: 10px;
    }

    .itemForm {
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/user/UserTeacherAgreement.vue